import classNames from 'classnames';

import { AvailabilityTimespan } from 'types/models/AvailabilityTimespan';

import classes from './RelativeAvailabilityTimespan.module.scss';

type Props = {
  timespan: AvailabilityTimespan;
};

const RelativeAvailabilityTimespan = ({ timespan }: Props): JSX.Element => (
  <span
    className={classNames({
      [classes.green]: timespan.type === 'GREEN',
      [classes.blue]: timespan.type === 'BLUE',
    })}
  >
    {timespan.name}
  </span>
);

export default RelativeAvailabilityTimespan;
